/**
 * @file Frame.js
 */

import { GenericFrame } from "../components/GenericFrame.tsx";
import { TopContents } from "./TopContents.tsx";
import { HowToDownload } from "./HowToDownload.tsx";
import { Download } from "./Download.tsx";
import { HowToInstallDeviceDriver } from "./HowToInstallDeviceDriver.tsx";
import { HowToUse } from "./HowToUse.tsx";
import { HelpAndSupport } from "./HelpAndSupport.tsx";
import { Version } from "./Version.tsx";
import { Windows11Supported } from "./Windows11Supported.tsx";
import { WindowsSupportEnd } from "./WindowsSupportEnd.tsx";
import { HowToUninstallDeviceDriver } from "./HowToUninstallDeviceDriver.tsx";

function CmcdFrame() {
  const navItems = [
    { path: "/cmcd-200", label: "CMCD-200トップ" },
    { path: "/cmcd-200/HowToDownload", label: "ダウンロード手順" },
    { path: "/cmcd-200/Download", label: "ダウンロード" },
    {
      path: "/cmcd-200/HowToInstallDeviceDriver",
      label: "デバイスドライバーのインストール方法",
    },
    { path: "/cmcd-200/HowToUse", label: "ロギングデータをパソコンで確認する" },

    {
      path: "/cmcd-200/HelpAndSupport",
      label: "トラブルシューティング",
      children: [
        {
          path: "/cmcd-200/HelpAndSupport/HowToUninstallDeviceDriver",
          label: "デバイスドライバーのアンインストール方法",
        },
      ],
    },
    { path: "/cmcd-200/Version", label: "バージョン情報" },
    { path: "/cmcd-200/Windows11Supported", label: "Windows 11対応のお知らせ" },
    {
      path: "/cmcd-200/WindowsSupportEnd",
      label: "Windowsの動作保証終了OSについて",
    },
  ];

  const trustedUrls = [
    "/cmcd-200",
    "/cmcd-200/HowToDownload",
    "/cmcd-200/Download",
    "/cmcd-200/HowToInstallDeviceDriver",
    "/cmcd-200/HowToUse",
    "/cmcd-200/HelpAndSupport",
    "/cmcd-200/HelpAndSupport/HowToUninstallDeviceDriver",
    "/cmcd-200/Version",
    "/cmcd-200/Windows11Supported",
    "/cmcd-200/WindowsSupportEnd",
  ];

  const routes = [
    { path: "/", element: <TopContents /> },
    { path: "/HowToDownload", element: <HowToDownload /> },
    { path: "/Download", element: <Download /> },
    {
      path: "/HowToInstallDeviceDriver",
      element: <HowToInstallDeviceDriver />,
    },
    { path: "/HowToUse", element: <HowToUse /> },
    { path: "/HelpAndSupport", element: <HelpAndSupport /> },
    {
      path: "/HelpAndSupport/HowToUninstallDeviceDriver",
      element: <HowToUninstallDeviceDriver />,
    },
    { path: "/Version", element: <Version /> },
    { path: "/Windows11Supported", element: <Windows11Supported /> },
    { path: "/WindowsSupportEnd", element: <WindowsSupportEnd /> },
  ];

  return (
    <GenericFrame
      navItems={navItems}
      trustedUrls={trustedUrls}
      routes={routes}
    />
  );
}
export default CmcdFrame;
